import {
  DirtyStateContext,
  ScopeResolutionContext,
  ScopeTransitionContext,
} from '@/providers/ScopeChangeProvider/contexts';
import { useContext } from 'react';

export function useScopeTransition() {
  const context = useContext(ScopeTransitionContext);
  return context;
}
export function useDirtyState() {
  const context = useContext(DirtyStateContext);
  return context;
}

export function useScopeResolution() {
  const context = useContext(ScopeResolutionContext);
  return context;
}

export function useUnsavedChangeActions() {
  const { markDirty, markClean } = useDirtyState();
  return { markDirty, markClean };
}

/**
 * @description A thin semantic wrapper around `useScopeTransition` to provide a more descriptive API.
 * @returns An object containing the `changeScope` function to request a scope transition.
 */
export const useScopeChangeAction = () => {
  const { requestTransition } = useScopeTransition();
  return { changeScopeTo: requestTransition };
};
